import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Modules
import { app } from './modules/app'
import { auth } from './modules/auth'
import { quickSpire } from './modules/quickSpire'
import { estimates } from './modules/estimates'
import { hubspot } from './modules/hubspot'
import { settings } from './modules/settings'

export default createStore({
  modules: {
    app,
    auth,
    quickSpire,
    estimates,
    hubspot,
    settings
  },
  
  plugins: [
    createPersistedState({
      key: 'vuex-state',
      paths: ['app.settings']
    })
  ],
  
  strict: import.meta.env.VITE_APP_ENV !== 'production'
}) 